import '../../common_screen/home_tab/index.css';
import { HeaderWithTimer, RouteWrapper, ScreenBackground } from '../../../component';
import ContestTab from '../contest_tab';
import MyContestTab from '../my_contest_tab';
import { HomeTabBar } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import MyAnswers from '../my_answer_tab';
import { useSelector } from 'react-redux';

const HomeTabMWeb = ({
  activeTab,
  routes,
  myContestList,
  matchItem,
  gameType,
  onCalledDeadline,
  onPressBack,
  onChangeIndex,
  onChangeTab,
  totalTeamsCount
}: any) => {
  const { teamName = '' } = useSelector((state: any) => state.user);
  return (
    <RouteWrapper>
      <ScreenBackground>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          gameType={gameType}
          teamName={teamName}
          isCreateTeam={false}
        />
        <HomeTabBar
          myTeamCount={totalTeamsCount}
          myContestsCount={myContestList[matchItem._id]?.length}
          activeTab={activeTab}
          onChangeTab={onChangeTab}
          routes={routes}
        />
        <SwipeableViews
          style={{ height: '100%', overflow: 'hidden' }}
          disableLazyLoading={true}
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <ContestTab />
          <MyContestTab onPressChangeTab={onChangeIndex} />
          <MyAnswers />
        </SwipeableViews>
      </ScreenBackground>
    </RouteWrapper>
  );
};

export default HomeTabMWeb;
